import { createFileRoute } from '@tanstack/react-router'

import {
  requireSession,
  TrialAddCardPage,
  type TrialSource,
} from '@/modules/auth'

interface AddCardSearch {
  name: string
  role?: string
  trial_source?: TrialSource
}

const isTrialSource = (value: unknown): value is TrialSource =>
  typeof value === 'object' && value !== null

export const Route = createFileRoute('/trial_/add-card')({
  staticData: { title: 'Add a card' },
  beforeLoad: requireSession,
  // A firm name like "1199" parses as a number from the query, so it is read back as text.
  validateSearch: (search: Record<string, unknown>): AddCardSearch => ({
    name: search.name === undefined ? '' : String(search.name),
    role: typeof search.role === 'string' ? search.role : undefined,
    trial_source: isTrialSource(search.trial_source)
      ? search.trial_source
      : undefined,
  }),
  component: TrialAddCard,
})

function TrialAddCard() {
  const { name, role, trial_source } = Route.useSearch()
  return (
    <TrialAddCardPage details={{ name, role, trialSource: trial_source }} />
  )
}
